import { Component, OnInit } from '@angular/core';
import { CommonService } from '../service/common.service';
import { EventService } from '../service/event.service';
import { AdminshareService } from "../service/adminshare.service";
import { UsersService } from '../service/users.service';
import { Router } from '@angular/router';

@Component({
    selector: 'admin-app',
    templateUrl: './admin.component.html',
    styleUrls: ['admin.component.css']
})
export class AdminComponent implements OnInit {
    isLoaded : boolean = false;
    datalist : any = [];
    publishmode : number =1;

    constructor(
        private commonService: CommonService,
        private eventService: EventService,
        private adminShareService: AdminshareService,
        public usersService: UsersService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.getList(1);
      };
    clearData (): void{
        this.isLoaded = false;
        this.datalist = [];
    }
    getList(mode:Number): void {
        this.clearData();
        let param ={
            publish_mode:mode,
            page:0,
            display_per_page:0
        };
        this.eventService.getEvent(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.datalist= res["fuel_results"]['event'];
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    public ChartColorsMonsin: Array<any>  = [
    { // all colors in order
            //未回答：赤
            //回答済：青
            //一時保存：黄      
        backgroundColor: [
            'rgba(255, 99, 132, 0.7)',
            'rgba(54, 162, 235, 0.7)',
            'rgba(255, 206, 86, 0.7)',
            ]
          }
      ];
    public ChartColorsYoyaku: Array<any>  = [
    { // all colors in order
        //未予約：赤
        //予約済：緑
        //受付済：青   
        //未受付：黄      
        backgroundColor: [
            'rgba(220, 53, 69, 0.7)',
            'rgba(23, 162, 184, 0.7)',
            'rgba(0, 123, 255, 0.7)',
            'rgba(255, 193, 7, 0.7)',
            ]
        }
    ];
    public ChartType: string = 'doughnut';
    public ChartOption: any = {
        legend: {
            //表示
            display: true,
            //押しても消えないようにするため、処理を上書き
            onClick:function(){
                return false;
            }
        },
        tooltips: {
            enabled:true,
            callbacks: {
                label: function(tooltipItems, data) {
                    return data.labels[tooltipItems.index];
                }
            }
        },
          animation: {
            duration: 500,
            easing: "easeOutQuart",
            onComplete: function () {
              var ctx = this.chart.ctx;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
        
              this.data.datasets.forEach(function (dataset) {
                  
                for (var i = 0; i < dataset.data.length; i++) {
                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                      total = dataset._meta[Object.keys(dataset._meta)[0]].total,
                      mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2,
                      start_angle = model.startAngle,
                      end_angle = model.endAngle,
                      mid_angle = start_angle + (end_angle - start_angle)/2;
        
                  var x = mid_radius * Math.cos(mid_angle);
                  var y = mid_radius * Math.sin(mid_angle);
        
                  ctx.fillStyle = '#333';
                  var percent = Math.round(dataset.data[i]/total*100);
                  if (percent >= 15){
                      ctx.fillText(dataset.data[i]+"人", model.x + x, model.y + y);
                      ctx.fillText(String(percent) + "%", model.x + x, model.y + y + 15);
                    }
                }
            });               
        }
          }  
    };
    togglePublish(mode:any){
        this.publishmode = mode;
        this.getList(mode);
    }
    edit(row){
        this.adminShareService.set_edit_event = row;
        this.router.navigate(["/event"]);
    }

    goQuestionList(qcid,m_language_id):void{
        this.router.navigate(["/question-list/" + qcid + "/" + m_language_id]);
    }
    goYoyakuList(qcid):void{
        this.router.navigate(["/yoyaku-list/" + qcid]);
    }
    //a0108個人データ
    setPerson(row: any): void {
        this.router.navigate(["/person/" + row.id]);
    }
    //a0106メール配信
    goMail(row: any): void {
        this.router.navigate(["/mail/" + row.id]);
    }
    //a0107状況確認
    goProgress(row: any): void {
        this.router.navigate(["/progress/" + row.id]);
    }
    goAnalysis(row: any): void{
        let topLangId = row.content[0]["m_language_id"];
        let topTQCId = row.content[0]["question_category"][0]["t_question_category_id"];
        this.router.navigate(["/result-analysis/"+topTQCId+"/"+topLangId]);
    }

}



// WEBPACK FOOTER //
// ./src/app/a0100-admin/admin.component.ts